<template>
    <div id="task">
        <div class="fix-up">
            <headers :title='titles'></headers>
            <div class="title clearfix">
                <span :class="{'noactive':!ti.hendler,'active':ti.hendler}"
                      @click="setTixing(ti.id,index)"
                      v-for="(ti,index) in titleList">{{ti.name}}<i :class="{'icon-zhankaixia':!ti.hendler,'icon-shang':ti.hendler}"></i></span>
            </div>
            <div class="list">
                <!-- 题型: -->
                <transition name="my-slide1"
                            tag="div">
                    <div class="tixing"
                         v-show="tixingShow"
                         :style="`height:${Math.ceil(tixingList.length/2) * 2.45 - 0.1}rem`">
                        <ul class="clearfix">
                            <li @click="choice_qtype(ti.id,index)"
                                v-for="(ti,index) in tixingList">
                                <i :class="{'icon-weixuanzhong':!ti.hendler,'icon-dianji':ti.hendler}"></i>
                                <span>{{ti.name}}</span>
                            </li>
                        </ul>
                    </div>
                </transition>
                <!-- 范围:  -->
                <transition name="my-slide2"
                            tag="div">
                    <div class="fanwei"
                         v-show="fanweiShow"
                         :style="`height:${Math.ceil(fanweiList.length/2) * 2.45 - 0.1}rem`">
                        <ul class="clearfix">
                            <li @click="choice_scope(ti.id,index)"
                                v-for="(ti,index) in fanweiList">
                                <i :class="{'icon-weixuanzhong':!ti.hendler,'icon-dianji':ti.hendler}"></i>
                                <span>{{ti.name}}</span>
                            </li>
                        </ul>
                    </div>
                </transition>
            </div>
        </div>
        <template>
            <div class="Space">
                <div v-if='!noResouse'
                     class="test"
                     v-for="item,index in questions">
                    <div class="question">
                        <i class="dge"
                           v-if='item.is_send'></i> <!--  发布标识 0 代表没有发过   1 发过 -->
                        <p class="title_t"
                           v-if="item.subject.content || item.subject.image">
                            <!-- <span>{{index+1}}、</span> -->
                            <span class="title_p"
                                  v-html="item.subject.content"></span>
                            <img :src="item.subject.image.url"
                                 v-if="item.subject.image && item.subject.image.url" />
                        </p>
                        <div v-if="item.listen_audio &&item.listen_audio!=''&& sid==92"
                             class="audio">
                            <div class="audio_warrp clearfix">
                                <div class="play_pause">
                                    <img :id="'isplay'+item.id"
                                         src="./img/icon_start.png"
                                         alt=""
                                         v-show="!item.hearing"
                                         @click="start(item,index)">
                                    <img :id="'pause'+item.id"
                                         v-show="item.hearing"
                                         src="./img/icon_suspend.png"
                                         alt=""
                                         @click="pause(item,index)">
                                </div>
                                <div class="audio_all"
                                     :id="'audio_all'+item.id">
                                    <div class="audio_now"
                                         :id="'audio_now'+item.id"></div>
                                </div>
                            </div>
                        </div>
                        <div v-for='ask,inx in item.asks'>
                            <p class="title_t"
                               v-if=" item.asks.length>1 || (ask.subject.content || ask.subject.image) &&ask.subject.content!=item.subject.content && item.type!=10 && item.type!=11">
                                <span v-if="item.asks.length>1">({{inx+1}})</span>
                                <span class="title_p"
                                      v-html="$options.filters.strReplace(ask.subject.content,'\#\#','或')"></span>
                                <img :src="ask.subject.image.url"
                                     v-if="ask.subject.image && ask.subject.image.url" />
                            </p>
                            <!-- 进度条 -->
                            <div v-if="ask.listen_audio &&ask.listen_audio!=''&& sid==91"
                                 class="audio">
                                <div class="audio_warrp clearfix">
                                    <div class="play_pause">
                                        <img :id="'isplay'+ask.id"
                                             src="./img/icon_start.png"
                                             alt=""
                                             v-show="!ask.hearing"
                                             @click="start(ask,index,inx)">
                                        <img :id="'pause'+ask.id"
                                             v-show="ask.hearing"
                                             src="./img/icon_suspend.png"
                                             alt=""
                                             @click="pause(ask,index,inx)">
                                    </div>
                                    <div class="audio_all"
                                         :id="'audio_all'+ask.id">
                                        <div class="audio_now"
                                             :id="'audio_now'+ask.id"></div>
                                    </div>
                                </div>
                                <!-- <Audio :ado="ask" :sid="sid"></Audio> -->
                            </div>
                            <!-- 进度条 -->
                            <div v-if="sid==91">
                                <!-- 选择题 -->
                                <div v-if="(item.type==1 || item.type==3 || item.type==4 || item.type==5 || item.type==6 || item.type==7 || item.type==8)">
                                    <choice :list='ask'
                                            :askLength='item.asks.length'
                                            :isAudio="ask.listen_audio"></choice>
                                </div>
                                <!-- 填空 -->
                                <div v-if='item.type==9'>
                                    <!-- 填空 -->
                                    <!-- <blanks :question='ask' :askLength='item.asks.length'></blanks> -->
                                </div>
                                <!-- 连词成句 -->
                                <div v-if='item.type==10'>
                                    <div class="mark">
                                        <span class="mark_answer"
                                              v-for="an in ask.answer">{{an}}</span>
                                    </div>
                                </div>
                                <!-- 连句成段 -->
                                <div v-if='item.type==11'>
                                    <div class="mark_line">
                                        <p class="mark_answer"
                                           v-for="an in ask.answer">{{an}}</p>
                                    </div>
                                </div>
                                <!-- 连线题 -->
                                <div class="line"
                                     v-if="item.type==2 && sid==91">
                                    <line-component :ask='ask'
                                                    :sheet="ask.answer"
                                                    :onlyshow='true'
                                                    :askLength='item.asks.length'></line-component>
                                </div>
                            </div>
                            <div v-if="sid==92">
                                <choice :list='ask'
                                        :askLength='item.asks.length'
                                        :isAudio="''"></choice>
                            </div>
                        </div>
                    </div>
                    <p class="taskbottom">
                        <span>使用次数: {{item.send_num}}次</span>
                        <span v-if='!item.selected'
                              :id='item.id'
                              class="Select"
                              @click='choice_question(item,index)'>加入</span>
                        <span :id='item.id'
                              v-else
                              class="remove"
                              @click='deled_question(item,index)'>移除</span>
                    </p>
                </div>
            </div>
        </template>
        <template>
            <loadingS v-if='firstLoad'></loadingS>
        </template>
        <template>
            <noResouse v-if='noResouse'></noResouse>
        </template>
        <moreLoading v-show='ismoreLoading'></moreLoading>
        <div class="bottom_btn clearfix">
            <div class="left_btn"><i></i><span>已选（{{getnselect}}题）</span></div>
            <div v-if='getnselect>0'
                 :class="['right_btn',{'able':getnselect>0}]"
                 @click='submit'>去发布</div>
            <div v-else
                 :class="['right_btn',{'disable':getnselect==0}]">去发布</div>
        </div>
        <!-- 遮罩层 -->
        <transition name="my-fade"
                    tag="div"
                    appear>
            <div class="mask"
                 @click="mask"
                 v-show="tixingShow || nanduShow || laiyuanShow || fanweiShow"></div>
        </transition>
        <div class="masking"
             v-if="prevBoon"
             @click="hidemask"></div>
    </div>
</template>

<script type="text/ecmascript-6">
import headers from 'COMPONENTS/base/header.vue'
import line from 'VIEWS/english/module/tea/line.vue';
import choice from 'VIEWS/english/module/tea/choose.vue'; //选择题
import Audio from 'VIEWS/english/module/tea/audio.vue';  //填空题
import loadingS from 'COMPONENTS/base/tealoading.vue';
import noResouse from 'COMPONENTS/noResouse.vue';
import moreLoading from 'COMPONENTS/moreLoading.vue';

export default {
    data () {
        return {
            firstLoad: true,
            questions: [],  // 搜索结果
            sources: [],    // 所有来源(练习册)
            qtype: 0,       // 题型
            dtype: 0,       // 难度
            source: 0,      // 当前来源
            scope: 0,       // 范围
            page: 1,        // 当前第几页
            hendler: true,
            tixingShow: false,
            nanduShow: false,
            laiyuanShow: false,
            fanweiShow: false,
            getQuestionTimer: null,
            tixingList: [
                { name: '全部', id: 0, hendler: true },
                { name: '选择题', id: 1 },
                { name: '连线', id: 2 },
                { name: '排序', id: 3 },
                { name: '判断正误', id: 4 },
                { name: '英汉互译', id: 5 },
                { name: '情景交际', id: 6 },
                { name: '完形填空', id: 7 },
                { name: '阅读理解', id: 8 },
                { name: '填空', id: 9 },
                { name: '连词成句', id: 10 },
                { name: '连句成段', id: 11 },
                // {name: '书面表达', id: 12}  //不做了
            ],
            fanweiList: [{ name: '全部', id: 0, hendler: true }, { name: '未发布过的试题', id: 1 }],
            titleList: [{ name: '题型', id: 0 }, { name: '范围', id: 3 }],
            titleList2: [{ name: '题型', id: 0 }, { name: '来源', id: 2 }, { name: '范围', id: 3 }],
            prevBoon: false,
            titles: '自己选题',
            sid: this.$route.params.sid,
            // sid:91,
            // type: this.$route.params.type,  //1同步习题 2 单元复习
            // searchlist:[], //
            noResouse: false,
            // totalNum:0,  //总题数
            isPost: true,
            getnselect: 0,//所选题数
            selectData: [],//所选题目
            qids: [],  //默认选中集合

            isfinish: true, //是否在暂停状态
            Speed: 1,
            proBar: null,  //原生定时器,
            listen_audio: null,
            listen_url: [],
            ismoreLoading: false,
        }
    },
    components: {
        headers,
        Audio,
        choice,
        'line-component': line,
        loadingS,
        noResouse,
        moreLoading
    },
    computed: {
        // getnselect() {
        //  // return this.$store.state.math.question.length;
        // },
    },
    beforeRouteLeave (to, from, next) {
        layer.closeAll();
        next();
    },
    // watch:{
    // },
    methods: {
        start (source, index, inx, e) {
            if ((source.duration < 0 || source.duration == 0) && this.sid == 91) {
                source.duration = 1
            }

            if ((source.listen_duration < 0 || source.listen_duration == 0) && this.sid == 92) {
                source.listen_duration = 1
            }
            // 全部初始话为true
            this.questions.forEach((m, n) => {
                m.hearing = false
                m.asks.forEach((l, i) => {
                    l.hearing = false
                })
            })
            source.hearing = true
            if (this.sid == 91) {
                this.questions[index].asks.splice(inx, 1, source)
            } else {
                this.questions.splice(index, 1, source)
            }


            this.proBar && clearInterval(this.proBar);
            this.getListTimer && clearTimeout(this.getListTimer);
            let _this = this
            let audio_now = document.querySelectorAll('.audio_now')

            // 判定是否是同一个音频地址
            if (this.listen_audio != source.listen_audio) {
                this.listen_audio = source.listen_audio
                //console.log('不一样')
                _this.Speed = 0;
                _this.isfinish = true
                for (var i = 0; i < audio_now.length; i++) {
                    audio_now[i].style.width = '0%';
                }
            } else {
                //console.log('一样')
            }
            let audio_nowID = document.getElementById('audio_now' + source.id) //获取进度条的元素

            let duration = source.duration * 10 || source.listen_duration * 10
            this.proBar = setInterval(() => {
                audio_nowID.style.width = (_this.Speed++) + '%';
                _this.isfinish = false
                if (_this.Speed > 100) {
                    _this.Speed = 1
                    for (var i = 0; i < audio_now.length; i++) {
                        audio_now[i].style.width = '0%';
                    }
                    source.hearing = false
                    if (_this.sid == 91) {
                        _this.questions[index].asks.splice(inx, 1, source)
                    } else {
                        _this.questions.splice(index, 1, source)
                    }
                    _this.proBar && window.clearInterval(_this.proBar);
                    _this.isfinish = true
                }
            }, duration);

            try {
                if (this.isfinish) {
                    // 播放
                    // appobject.Interactive("ys_stop_audio");
                    // appobject.Interactive("ys_start_audio," + source.listen_audio);
                    this.appFunction("ys_stop_audio");
                    this.appFunction("ys_start_audio", source.listen_audio);
                } else {
                    // 继续播放
                    // appobject.Interactive("ys_goon_audio");
                    this.appFunction("ys_goon_audio");
                }
            } catch (e) {
                //console.log(22)
            }

            // 原生回调 回复样式
            window.playfinished = function () {
                _this.Speed = 1
                for (var i = 0; i < audio_now.length; i++) {
                    audio_now[i].style.width = '0%';
                }
                source.hearing = false
                if (_this.sid == 91) {
                    _this.questions[index].asks.splice(inx, 1, source)
                } else {
                    _this.questions.splice(index, 1, source)
                }
                _this.proBar && window.clearInterval(_this.proBar);
                _this.isfinish = true;
            }
        },
        pause (source, index, inx) {
            // try {
            //   appobject.Interactive('ys_pause_audio')
            // } catch (e) {
            //   // //console.log(e)
            // }
            this.appFunction('ys_pause_audio');
            source.hearing = false;
            if (this.sid == 91) {
                this.questions[index].asks.splice(inx, 1, source)
            } else {
                this.questions.splice(index, 1, source)
            }
            this.proBar && window.clearInterval(this.proBar);
        },
        hidemask () {
            // 隐藏遮罩
            this.prevBoon = false;
        },
        setTixing (id, i) {
            // 题型  范围 选择
            if (!this.titleList[i].hendler) {
                this.titleList.forEach(ti => {
                    ti.hendler = false;
                })
                if (id == 0) {
                    this.tixingShow = true;
                    this.fanweiShow = false;
                } else if (id == 1) {
                    this.tixingShow = false;
                    this.fanweiShow = false;
                } else if (id == 2) {
                    this.tixingShow = false;
                    this.fanweiShow = false;
                } else {
                    this.tixingShow = false;
                    this.fanweiShow = true;
                }
            } else {
                this.tixingShow = false;
                this.fanweiShow = false;
            }
            this.titleList[i].hendler = !this.titleList[i].hendler;
            this.titleList.splice(i, 1, this.titleList[i]);
        },
        mask () {
            this.titleList.forEach(ti => {
                ti.hendler = false;
            })
            this.titleList2.forEach(ti => {
                ti.hendler = false;
            })
            this.tixingShow = false;
            this.nanduShow = false;
            this.fanweiShow = false;
        },
        clearlist () {
            this.questions = [];
        },
        choice_qtype (qtype, i) {
            window.scrollTo(0, 0);
            // 题型范围选择
            this.qtype = qtype;
            this.page = 1;
            this.tixingList.forEach(d => {
                d.hendler = false;
            })
            this.tixingList[i].hendler = true;
            this.tixingList.splice(i, 1, this.tixingList[i]);
            this.clearlist();
            this.search();
            this.mask();
            this.firstLoad = true;
        },
        choice_question (question, index) {
            this.qids.push(question.id)
            // 添加试题试题
            // if ((this.getnselect + question.asks.length) > 30) {
            //   layer.tips('已经超出30道题，不能再添加试题了');
            //   return false
            // }
            if (this.sid == 91) {
                if ((this.getnselect + question.asks.length) > 50) {
                    layer.tips('已经超出50道题，不能再添加试题了');
                    return false
                }
            } else if (this.sid == 92) {
                if ((this.getnselect + question.asks.length) > 100) {
                    layer.tips('已经超出100道题，不能再添加试题了');
                    return false
                }
            }
            question.selected = !question.selected;
            this.questions.splice(index, 1, question);
            let obj = {
                qid: question.id,
                q_no: index + 1
            };
            this.selectData.push(obj);
            this.getnselect += question.asks.length;

        },
        deled_question (question, index) {

            // 移除试题试题
            question.selected = !question.selected
            let obj = {}
            obj.id = question.id
            this.questions.splice(index, 1, question)
            let _index = this.selectData.findIndex(item => item.id == question.id);
            this.selectData.splice(_index, 1);
            this.getnselect -= question.asks.length;
            this.qids.forEach((m, n) => {
                if (m == question.id) {
                    this.qids.splice(n, 1)
                }
            })
        },
        choice_scope (scope, i) {
            window.scrollTo(0, 0);
            // 范围选择试题
            this.scope = scope;
            this.page = 1;
            this.fanweiList.forEach(d => {
                d.hendler = false;
            })
            this.fanweiList[i].hendler = true;
            this.fanweiList.splice(i, 1, this.fanweiList[i]);
            this.clearlist();
            this.search();
            this.mask();
            this.firstLoad = true;
        },
        submit () {//跳转发布
            // if (this.getnselect > 30) {
            //   layer.tips('已经超出30道题了，无法发布');
            //   return false
            // }
            if (this.sid == 91) {
                if (this.getnselect > 50) {
                    layer.tips('已经超出50道题了，无法发布');
                    return false
                }
            } else if (this.sid == 92) {
                if (this.getnselect > 100) {
                    layer.tips('已经超出100道题了，无法发布');
                    return false
                }
            }
            this.$store.commit('setSendData', this.selectData)
            this.$router.push('/english/release/' + this.sid + '/2')
        },
        setShow (ask) {
            let tempclose = !ask.close;
            this.$set(ask, "close", tempclose);
            this.questions.forEach(val => {
                val.asks.forEach(askobj => {
                    if (askobj !== ask) {
                        this.$set(askobj, "close", false);
                    }
                });
            })
        },

        search () {
            return (async () => {
                let qids_s;
                let qmap;
                let cid = this.$store.state.english.taskCatalog.join(',')
                let that = this
                this.isPost = true
                if (this.isPost) {
                    this.isPost = false
                    await this.$http.post(API_URL_TASK_API + '/english/send/change/task', {
                        catalog_ids: cid,
                        sid: this.sid,
                        type: this.qtype,   //填空题 1填 0不填
                        page: this.page,
                        scope: this.scope
                    }).then((res) => {
                        if (res.data.response === 'ok') {
                            this.isPost = true
                            this.firstLoad = false;
                            this.ismoreLoading = false;
                            let questions = "";
                            if (!res.data.data.length && this.page != 1) {
                                this.page = 0;
                                layer.tips('已加载全部内容');
                                this.isPost = false;
                                return false;
                            } else if (!res.data.data.length) {
                                this.noResouse = true
                            } else {
                                this.noResouse = false
                                questions = res.data.data;
                            }
                            this.questions = [...this.questions, ...questions];
                            this.questions.forEach((m, n) => {
                                m.hearing = false  //听力条
                                m.asks.forEach((h, r) => {
                                    h.hearing = false  //听力条
                                })
                                this.qids.forEach((l, i) => {
                                    if (m.id == l) {
                                        m.selected = true
                                    }
                                })
                            })
                        }
                    })
                }
            })();
        },
        getQuestion () {//下拉加载
            let that = this;
            this.getQuestionTimer && clearTimeout(this.getQuestionTimer);
            this.getQuestionTimer = setTimeout(function () {
                let docHeight = document.body.scrollHeight;
                let scrollTop = document.body.scrollTop || document.documentElement.scrollTop;
                let winHeight = window.screen.availHeight;
                if (winHeight + scrollTop >= docHeight - 20 && that.isPost) {
                    //console.log('下拉加载')
                    that.ismoreLoading = true;
                    that.page++;
                    that.search();
                }
            }, 500)
        }
    },
    created () {
        let _sendok = localStorage.getItem('sendok');
        let _cids = this.$store.state.english.taskCatalog;
        if (_sendok || !_cids.length) {
            this.$router.go(-1);
            return false;
        }
        this.search();
        if (this.sid == 92) {
            this.tixingList = [
                { name: '全部', id: 0, hendler: true },
                // {name: '听力', id: 1},
                { name: '单项选择', id: 2 },
                { name: '完形填空', id: 3 },
                { name: '阅读理解', id: 4 }
            ]
        }
        window.addEventListener('scroll', this.getQuestion, true)
    },
    destroyed () {
        // try{
        //   appobject.Interactive("ys_stop_audio");
        // }catch(e){}
        this.appFunction("ys_stop_audio");
        this.$store.state.math.qid = []  //销毁所有选中的id
        this.proBar && window.clearInterval(this.proBar);
        window.removeEventListener('scroll', this.getQuestion, true)
    }
}
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
@import "SRC/assets/scss/common/_mixin";

#task {
    min-height: 100vh;
    position: relative;
    padding-bottom: 120px / $ppr;
}

.icon-zhankaixia,
.icon-shang {
    display: inline-block;
    margin-left: 20px / $ppr;
    width: 20px / $ppr;
    height: 20px / $ppr;
}

.icon-zhankaixia {
    background: url("./img/icon_open.png");
    background-size: contain;
    background-repeat: no-repeat;
}

.icon-shang {
    background: url("./img/icon_close.png");
    background-size: contain;
    background-repeat: no-repeat;
}

.icon-weixuanzhong,
.icon-dianji {
    display: inline-block;
    width: 40px / $ppr;
    height: 40px / $ppr;
}

.icon-weixuanzhong {
    background: url("./img/icon_unchecked.png");
    background-size: contain;
    background-repeat: no-repeat;
}

.icon-dianji {
    background: url("./img/circle.png");
    background-size: contain;
    background-repeat: no-repeat;
}

.fix-up {
    z-index: 20;
}

.title {
    position: fixed;
    left: 0;
    right: 0;
    z-index: 4;
    background: $c-fbg;
    padding: $w 0;
    height: 46px / $ppr;
    border-bottom: 1px / $ppr solid #dcdcdc;
    span {
        display: block;
        float: left;
        line-height: 46px / $ppr;
        width: 50%;
        text-align: center;
        box-sizing: border-box;
        border-right: 1px / $ppr solid #dcdcdc;
        i {
            padding-left: 10px / $ppr;
            color: $c-tag;
        }
        &.active {
            color: #5e89ef;
        }
    }
    span:last-child {
        border-right: none;
    }
}

.line {
    padding-top: 20px / $ppr;
    background: #fff;
}

.list {
    position: fixed;
    left: 0;
    right: 0;
    top: 191px / $ppr;
    z-index: 100;
    ul {
        position: relative;
        z-index: 10;
        background: $c-fbg;
        li {
            float: left;
            width: 50%;
            line-height: $h-header;
            height: $h-header;
            box-sizing: border-box;
            display: flex;
            display: -webkit-flex;
            display: -webkit-box;
            align-items: center;
            -webkit-align-items: center;
            i {
                margin-left: 40px / $ppr;
                position: relative;
                top: 10px / $ppr;
                padding-right: 10px / $ppr;
            }
            .icon-dianji {
                color: $c-tag;
            }
        }
    }
}

.mask {
    position: fixed;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: $mask;
    z-index: 3;
    transition: background-color 0.3s linear;
}

.title_t {
    background: $c-fbg;
    padding: $w;
    line-height: 48px / $ppr;
    border-bottom: 1px / $ppr solid #dcdcdc;
    .title_p {
        word-break: break-all;
    }
}

.Space {
    margin-top: 120px / $ppr;
    //padding-bottom:120px/$ppr;
}

.test {
    margin-top: 30px / $ppr;
    .question {
        position: relative;
        .dge {
            width: 100px / $ppr;
            height: 56px / $ppr;
            position: absolute;
            right: 0;
            top: 20px / $ppr;
            z-index: 2;
            background: url("./img/icon_to.png");
            background-size: 100% 100%;
            background-repeat: no-repeat;
        }
    }
    ul {
        li {
            padding: $w;
            line-height: 48px / $ppr;
            border-bottom: 1px / $ppr solid #dcdcdc;
            position: relative;
            i {
                position: absolute;
                top: $w;
                left: $w;
                text-align: center;
                display: inline-block;
                width: 50px / $ppr;
                height: 50px / $ppr;
                line-height: 50px / $ppr;
                border-radius: 50%;
                &.i_equal {
                    border: #66cc22 1px / $ppr solid;
                    background: #66cc22;
                    color: #fff;
                }
                &.i_noequal {
                    border: $line 1px / $ppr solid;
                }
            }
            p {
                display: inline-block;
                width: 580px / $ppr;
                padding-left: 80px / $ppr;
                &.p_equal {
                    color: #66cc22;
                }
            }
        }
    }
    position: relative;
    .taskbottom {
        line-height: $h-header;
        height: $h-header;
        padding: 0 $w;
        font-size: $lt;
        color: $c-light;
        position: relative;
        background: #fff;
        span:nth-of-type(2) {
            line-height: 50px / $ppr;
            text-align: center;
            width: 122px / $ppr;
            height: 48px / $ppr;
            line-height: 50px / $ppr;
            position: absolute;
            top: 20px / $ppr;
            right: 20px / $ppr;
            border-radius: 50px / $ppr;
            border: 1px / $ppr solid red;
            &.Select {
                color: #5e89ef;
                border: 1px / $ppr solid #5e89ef;
            }
            &.remove {
                color: #ff6600;
                border: 1px / $ppr solid #ff6600;
            }
        }
    }
}

.mark {
    padding: 25px / $ppr 15px / $ppr;
    background: #fff;
    border-bottom: 1px / $ppr solid #dcdcdc;
    span {
        display: inline-block;
        color: #66cc22;
        border-bottom: 1px / $ppr solid #66cc22;
        margin: 0 20px / $ppr;
        line-height: 46px / $ppr;
        height: 46px / $ppr;
    }
}

.mark_line {
    padding: 25px / $ppr;
    background: #fff;
    border-bottom: 1px / $ppr solid #dcdcdc;
    p {
        // display:inline-block;
        color: #66cc22;
        border-bottom: 1px / $ppr solid #66cc22;
        margin: 0 20px / $ppr;
        line-height: 46px / $ppr;
        height: 46px / $ppr;
    }
}

.masking {
    width: 100vw;
    height: 100vh;
    position: fixed;
    bottom: 0;
    left: 0;
    background: #000;
    opacity: 0.6;
    z-index: 10;
}

.bottom_btn {
    width: 100%;
    height: 96px / $ppr;
    line-height: 96px / $ppr;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    z-index: 2;
    font-size: 30px / $ppr;
    text-align: center;
    .left_btn {
        width: 70%;
        float: left;
        background: #f0f0f0;
        color: #333;
        position: relative;
        i {
            position: absolute;
            z-index: 1;
            top: 25px / $ppr;
            display: inline-block;
            width: 50px / $ppr;
            height: 42px / $ppr;
            background: url("./img/icon1.png") 0 0 no-repeat;
            background-size: 100% 100%;
        }
        span {
            display: inline-block;
            padding-left: 60px / $ppr;
        }
    }
    .right_btn {
        width: 30%;
        float: right;
    }
    .able {
        color: #fff;
        background: #5e89ef;
    }
    .disable {
        color: #999;
        background: #ccc;
    }
}
.audio {
    .audio_warrp {
        position: relative;
        width: 100%;
        height: 96px / $ppr;
    }
    .audio_all {
        width: 560px / $ppr;
        height: 24px / $ppr;
        background-color: #c9c9c9;
        position: absolute;
        top: 50%;
        right: 60px / $ppr;
        margin-top: -12px / $ppr;
        border-radius: 12px / $ppr;
        overflow: hidden;
        .audio_now {
            width: 0%;
            height: 100%;
            background-color: #5e89ef;
            border-radius: 12px / $ppr;
        }
    }
    .play_pause {
        width: 54px / $ppr;
        height: 54px / $ppr;
        border-radius: 50%;
        position: absolute;
        top: 21px / $ppr;
        left: 25px / $ppr;
        img {
            width: 54px / $ppr;
            height: 54px / $ppr;
        }
    }
}
.my-fade-enter,
.my-fade-leave-to {
    background-color: rgba(0, 0, 0, 0);
}
.tixing,
.fanwei {
    height: 0;
    overflow: hidden;
    transition: height 0.3s linear;
}
.my-slide1-enter,
.my-slide1-leave-to,
.my-slide2-enter,
.my-slide2-leave-to {
    height: 0 !important;
}
</style>
